import * as React from 'react';

// Types
import { IconProps } from './types';

const Person = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={25}
    fill="none"
    {...props}
  >
    <path
      fill="#E3D2FF"
      d="M9.373 3.875a2.625 2.625 0 1 1 5.25 0 2.625 2.625 0 0 1-5.25 0Zm10.82 9.823-4.242-4.81A2.625 2.625 0 0 0 13.983 8h-3.97a2.625 2.625 0 0 0-1.969.889l-4.242 4.81a1.5 1.5 0 0 0 2.115 2.126l2.425-1.947-1.847 7.02A1.5 1.5 0 0 0 9.22 22.15l2.777-4.775 2.773 4.781a1.5 1.5 0 0 0 2.726-1.251l-1.843-7.027 2.428 1.947a1.5 1.5 0 0 0 2.115-2.127h-.003Z"
    />
  </svg>
);
export default Person;
